import { List, ListItem, ListItemButton, ListItemIcon, ListItemText, Tooltip } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import React from 'react';
import MessageIcon from '@mui/icons-material/Message';
import PeopleIcon from '@mui/icons-material/People';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import PaymentIcon from '@mui/icons-material/Payment';
import SensorsIcon from '@mui/icons-material/Sensors';
import { useAuth } from '../../hooks/useAuth';
import { ROLES } from '../../helpers/constants';

function SiderbarMenuItem({ icon, title, open, ...otherProps }) {
    return (
        <ListItem disablePadding sx={{ display: 'block' }}>
            <Tooltip title={open ? '' : title} placement="right">
                <ListItemButton
                    {...otherProps}
                    sx={{
                        minHeight: 48,
                        px: 2.5,
                    }}
                >
                    <ListItemIcon
                        sx={{
                            minWidth: 0,
                            mr: 2,
                            justifyContent: 'center',
                        }}
                    >
                        {icon}
                    </ListItemIcon>
                    <ListItemText
                        primary={title}
                        sx={{ opacity: open ? 1 : 0, transition: 'opacity 0.3s' }}
                    />
                </ListItemButton>
            </Tooltip>
        </ListItem>
    );
}

export default function SidebarMenu({ open }) {
    const navigate = useNavigate();
    const { user } = useAuth();
    const isAdmin = user.role === ROLES.ADMIN;

    return (
        <List style={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
            {isAdmin && (
                <>
                    <SiderbarMenuItem
                        open={open}
                        title="Felhasználók"
                        icon={<PeopleIcon />}
                        onClick={() => {
                            navigate('/users');
                        }}
                    />
                    <SiderbarMenuItem
                        open={open}
                        title="Parkolások"
                        icon={<DirectionsCarIcon />}
                        onClick={() => {
                            navigate('/parkings');
                        }}
                    />
                    {/* not exposed yet, the page is reachable at /liveparking */}
                    {false && (
                        <SiderbarMenuItem
                            open={open}
                            title="Élő forgalom"
                            icon={<SensorsIcon />}
                            onClick={() => {
                                navigate('/liveparking');
                            }}
                        />
                    )}
                    <SiderbarMenuItem
                        open={open}
                        title="Napló"
                        icon={<MessageIcon />}
                        onClick={() => {
                            navigate('/auditlogs');
                        }}
                    />
                    <SiderbarMenuItem
                        open={open}
                        title="Fizetések"
                        icon={<PaymentIcon />}
                        onClick={() => {
                            navigate('/payments');
                        }}
                    />
                </>
            )}
        </List>
    );
}
